import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1280.000000 851.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,851.000000) scale(0.100000,-0.100000)">

<path d="M5413 5613 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z"/>
<path d="M5584 5483 c7 -7 108 -5 115 3 2 2 -24 4 -59 4 -35 0 -60 -3 -56 -7z"/>
<path d="M5178 5473 c12 -2 32 -2 45 0 12 2 2 4 -23 4 -25 0 -35 -2 -22 -4z"/>
<path d="M5490 5340 l0 -59 -72 -4 -73 -3 78 -2 77 -2 0 65 c0 36 -2 65 -5 65
-3 0 -5 -27 -5 -60z"/>
<path d="M5200 5160 l-35 -7 38 -2 c20 0 37 4 37 9 0 6 -1 9 -2 9 -2 -1 -19
-5 -38 -9z"/>
<path d="M6028 5013 c18 -2 45 -2 60 0 15 2 0 4 -33 4 -33 0 -45 -2 -27 -4z"/>
<path d="M6138 5003 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M5012 4935 c-3 -60 -5 -66 -14 -45 -6 15 -12 20 -15 13 -3 -7 -14
-13 -26 -13 -18 0 -19 2 -7 10 22 14 -13 12 -80 -5 -101 -26 -139 -40 -156
-60 -8 -11 -12 -13 -8 -5 5 12 4 12 -6 3 -13 -12 -33 -287 -28 -401 2 -51 7
-67 19 -70 25 -5 315 165 325 191 2 7 3 111 1 232 -1 121 -4 189 -5 150z"/>
<path d="M6583 4805 c-45 -19 -41 -28 5 -11 20 8 44 17 52 19 10 4 9 6 -5 6
-11 0 -35 -6 -52 -14z"/>
<path d="M7162 4804 c-29 -12 -70 -59 -60 -69 3 -3 10 6 18 19 14 27 47 43 95
48 l30 3 -27 6 c-14 3 -40 0 -56 -7z"/>
<path d="M8085 4805 c-39 -18 -31 -18 25 -1 25 8 36 15 25 15 -11 0 -33 -6
-50 -14z"/>
<path d="M8945 4810 c-12 -4 -27 -16 -35 -26 -14 -16 -13 -16 14 1 16 11 43
18 60 18 26 -2 28 0 11 7 -25 11 -25 11 -50 0z"/>
<path d="M9331 4804 c-19 -8 -31 -17 -28 -20 3 -3 16 0 29 7 12 7 41 16 63 20
l40 6 -35 1 c-19 1 -50 -5 -69 -14z"/>
<path d="M9448 4813 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M7624 4788 l-19 -21 30 18 c41 26 40 25 23 25 -8 0 -23 -10 -34 -22z"/>
<path d="M8629 4781 c-16 -16 -29 -35 -29 -43 0 -7 9 2 20 19 11 18 30 35 42
37 13 3 32 7 43 9 11 3 6 5 -13 6 -25 1 -41 -7 -63 -28z"/>
<path d="M9158 4608 l-3 -152 -46 3 c-26 1 -50 -2 -54 -8 -4 -7 14 -11 54 -11
l61 0 0 160 c0 88 -2 160 -5 160 -2 0 -6 -68 -7 -152z"/>
<path d="M5453 4663 c-131 -175 -313 -351 -481 -467 -362 -248 -798 -440
-1116 -491 -153 -25 -357 -16 -426 19 -17 8 -27 10 -24 4 25 -40 178 -61 351
-48 185 14 374 63 683 179 74 28 143 51 153 51 26 0 21 -20 -5 -21 -22 -1 -22
-1 2 -8 23 -7 21 -9 -25 -26 -27 -10 -70 -26 -94 -37 -24 -10 -67 -21 -95 -24
-28 -4 -60 -10 -71 -15 -30 -12 70 0 145 18 147 35 441 177 575 277 79 58 72
59 -20 0 -66 -41 -198 -109 -208 -106 -5 1 -6 -2 -2 -8 4 -6 -1 -7 -11 -3 -14
5 -13 8 7 25 13 11 -18 -2 -68 -28 -51 -26 -95 -45 -97 -43 -3 3 35 27 85 54
242 133 526 350 504 385 -4 6 -2 10 2 10 5 0 15 11 23 24 8 13 44 56 80 96 57
64 170 207 170 217 0 10 -12 -1 -37 -34z m-713 -733 c-8 -5 -19 -10 -25 -10
-5 0 -3 5 5 10 8 5 20 10 25 10 6 0 3 -5 -5 -10z"/>
<path d="M6633 4644 c-18 -9 -33 -21 -33 -25 0 -5 11 -2 25 7 14 9 48 20 77
24 l53 8 -45 1 c-25 0 -60 -7 -77 -15z"/>
<path d="M8144 4646 c-18 -8 -35 -19 -38 -25 -10 -16 5 -13 24 4 9 9 44 19 76
24 58 8 58 9 14 9 -25 1 -59 -5 -76 -12z"/>
<path d="M9413 4652 c-35 -11 -63 -40 -62 -64 2 -22 2 -22 6 -2 7 35 34 52 98
62 50 8 53 10 20 10 -22 0 -50 -3 -62 -6z"/>
<path d="M8383 4570 c0 -30 2 -43 4 -27 2 15 2 39 0 55 -2 15 -4 2 -4 -28z"/>
<path d="M6873 4540 c0 -41 2 -58 4 -37 2 20 2 54 0 75 -2 20 -4 3 -4 -38z"/>
<path d="M5504 4588 c-4 -7 -15 -24 -23 -38 -10 -15 -11 -21 -3 -16 13 7 46
66 38 66 -3 0 -8 -6 -12 -12z"/>
<path d="M6351 4572 c-57 -81 -151 -113 -345 -117 -76 -2 -141 -6 -144 -9 -3
-4 53 -6 124 -6 195 0 302 33 369 116 20 24 32 44 26 44 -5 0 -19 -13 -30 -28z"/>
<path d="M7903 4525 c0 -38 2 -53 4 -32 2 20 2 52 0 70 -2 17 -4 1 -4 -38z"/>
<path d="M4485 4560 c-11 -5 -35 -9 -52 -9 -18 -1 -33 -5 -33 -10 0 -11 -75
-32 -125 -34 -39 -2 -40 -4 -51 -47 -6 -25 -15 -116 -18 -203 -6 -134 -5 -158
8 -163 8 -3 90 30 183 73 l168 79 0 147 c0 134 -2 147 -20 161 -23 17 -32 18
-60 6z"/>
<path d="M5441 4490 c-12 -17 -21 -35 -19 -40 2 -5 13 8 26 30 27 48 24 52 -7
10z"/>
<path d="M6744 4496 c-10 -26 -78 -48 -137 -44 -62 3 -67 -7 -8 -17 53 -9 111
9 146 45 16 16 23 30 17 30 -7 0 -15 -6 -18 -14z"/>
<path d="M7764 4496 c-8 -20 -75 -39 -127 -35 -25 2 -43 1 -40 -3 2 -5 29 -8
59 -8 55 0 134 30 134 50 0 15 -20 12 -26 -4z"/>
<path d="M8250 4495 c-36 -43 -140 -62 -191 -34 -22 11 -23 11 -11 -4 18 -22
82 -30 131 -17 42 11 101 53 90 64 -3 4 -12 -1 -19 -9z"/>
<path d="M9494 4491 c-44 -40 -102 -54 -169 -38 l-30 7 30 -14 c36 -18 58 -19
105 -6 35 10 115 69 94 70 -5 0 -19 -8 -30 -19z"/>
<path d="M6780 4450 c0 -5 23 -10 50 -10 28 0 50 5 50 10 0 6 -22 10 -50 10
-27 0 -50 -4 -50 -10z"/>
<path d="M6990 4450 c0 -5 24 -10 54 -10 30 0 58 5 61 10 4 6 -17 10 -54 10
-34 0 -61 -4 -61 -10z"/>
<path d="M7280 4450 c0 -6 27 -10 60 -10 33 0 60 4 60 10 0 6 -27 10 -60 10
-33 0 -60 -4 -60 -10z"/>
<path d="M8283 4448 c-2 -5 19 -8 46 -8 28 0 51 3 51 8 0 4 -21 7 -46 7 -25 0
-48 -3 -51 -7z"/>
<path d="M8490 4450 c-11 -7 3 -10 48 -10 35 0 62 4 62 10 0 13 -90 13 -110 0z"/>
<path d="M8770 4450 c0 -5 25 -10 55 -10 30 0 55 5 55 10 0 6 -25 10 -55 10
-30 0 -55 -4 -55 -10z"/>
<path d="M9540 4449 c0 -5 23 -9 52 -9 28 0 48 3 44 7 -10 10 -96 12 -96 2z"/>
<path d="M4099 4353 c0 -33 -3 -42 -8 -29 -5 14 -10 16 -15 8 -4 -7 -15 -12
-24 -12 -9 0 -29 -7 -44 -14 -37 -19 -68 -22 -156 -12 -53 6 -76 13 -80 25
-13 31 -49 -319 -38 -365 6 -24 10 -26 46 -20 21 3 104 29 184 57 l146 51 0
179 c0 98 -2 179 -5 179 -3 0 -5 -21 -6 -47z"/>
<path d="M7880 4389 c-1 -22 -44 -66 -88 -88 -50 -26 -162 -28 -236 -6 -54 16
-76 12 -30 -5 86 -33 198 -35 271 -5 50 21 107 94 89 112 -3 4 -6 0 -6 -8z"/>
<path d="M5304 4308 l-19 -23 23 19 c12 11 22 21 22 23 0 8 -8 2 -26 -19z"/>
<path d="M3520 4249 c-53 -59 -82 -126 -86 -198 l-3 -66 8 55 c10 68 37 131
84 193 42 53 40 63 -3 16z"/>
<path d="M5990 4210 c0 -6 32 -10 78 -9 56 1 69 3 47 9 -45 11 -125 11 -125 0z"/>
<path d="M5982 3990 c-1 -41 -5 -60 -11 -51 -7 10 -10 10 -13 1 -2 -7 -15 -14
-28 -16 -66 -7 -68 -9 -69 -158 l-1 -108 153 4 c125 4 162 9 209 27 106 41
188 156 188 264 0 27 -3 37 -9 29 -6 -9 -23 -13 -52 -10 -40 3 -45 6 -50 33
-6 26 -7 24 -8 -15 -4 -152 -107 -242 -253 -224 l-47 7 -4 141 c-1 77 -4 112
-5 76z"/>
<path d="M7158 4043 c-32 -2 -58 -7 -58 -11 0 -4 27 -5 60 -4 33 2 60 8 60 13
0 5 -1 8 -2 7 -2 -1 -29 -3 -60 -5z"/>
<path d="M7409 4040 c-36 -10 -69 -29 -69 -40 0 -5 21 0 46 12 34 15 60 19 96
16 27 -3 46 -2 41 2 -12 12 -85 18 -114 10z"/>
<path d="M4870 4030 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M6568 4023 c-21 -8 -38 -20 -38 -25 0 -5 3 -8 8 -6 58 30 91 39 133
36 26 -1 45 0 42 5 -8 13 -107 7 -145 -10z"/>
<path d="M6943 4033 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z"/>
<path d="M4830 4020 c-12 -7 -10 -9 7 -7 12 0 19 5 17 9 -6 10 -6 10 -24 -2z"/>
<path d="M6840 3955 c-1 -47 -3 -55 -10 -37 -5 12 -7 28 -4 36 3 7 -2 16 -10
19 -9 4 -16 2 -16 -3 0 -6 5 -10 12 -10 8 0 9 -3 2 -10 -6 -6 -51 -13 -100
-17 -153 -10 -230 -52 -241 -131 -16 -123 129 -193 241 -117 l36 24 6 -24 c6
-22 11 -25 55 -25 l49 0 -1 158 c0 86 -4 166 -9 177 -6 14 -9 3 -10 -40z m-90
-120 c0 -96 -149 -131 -158 -38 -4 35 16 51 78 64 74 14 80 12 80 -26z"/>
<path d="M7091 3975 c-1 -23 -4 -27 -11 -15 -8 12 -10 11 -10 -5 0 -28 -56
-34 -63 -8 -8 36 -19 -81 -15 -153 4 -60 9 -79 28 -99 35 -37 93 -50 158 -35
l53 12 -6 41 c-9 55 -12 58 -38 46 -15 -7 -31 -7 -50 0 -27 10 -27 11 -28 108
0 54 -4 107 -9 118 -7 17 -9 16 -9 -10z"/>
<path d="M7650 3965 c0 -8 -9 -15 -19 -15 -11 0 -22 -4 -25 -8 -3 -5 -41 -9
-85 -11 -46 -1 -108 -10 -144 -21 -54 -17 -66 -25 -85 -59 -26 -45 -27 -69 -8
-116 35 -83 175 -109 244 -45 27 25 30 25 34 -2 3 -21 9 -23 56 -23 28 0 52 3
52 8 0 4 0 75 0 157 0 93 -4 150 -10 150 -5 0 -10 -7 -10 -15z m-96 -103 c9
-15 -12 -83 -31 -97 -70 -54 -170 2 -120 68 19 25 139 48 151 29z"/>
<path d="M4495 3850 c-16 -7 -17 -9 -3 -9 9 -1 20 4 23 9 7 11 7 11 -20 0z"/>
</g>
</svg>








    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
